<template>
  <div class="localness" id="localness" style="display:none">
    <h3>What do people talk about on Twitter in {{store.state.currentNeighborhood}}</h3>
    These are terms that are used more often in {{store.state.currentNeighborhood}} than in other neighborhoods. Click each word for context.
    <ul>
      <li v-for="tweetword in top10TweetTfidf">
        <span v-on:click="expandTweetWord(tweetword['word'])" >{{tweetword['word']}}</span>
        <div v-show="expanded.indexOf(tweetword['word']) >= 0">
          <ul>
            <li v-for="sentence in tweetword['context']">
            {{sentence}}
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <br/>
  </div>
</template>


<script>
import store from '../store/store.js'
// import { mapGetters } from 'vuex'

// Yes, we're managing state here, but it's all local. Plus I got into a big
// mess trying to manage it more globally.
let expanded = []
let expandTweetWord = function (word) {
  if (expanded.indexOf(word) >= 0) {
    expanded.splice(expanded.indexOf(word), 1)
  } else {
    expanded.push(word)
  }
}

export default {
  computed: {
    top10TweetTfidf: function () {
      return store.getters.top10TweetTfidf
    }
  },
  data () {
    return {
      store: store,
      expandTweetWord: expandTweetWord,
      expanded: expanded
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
span {
  cursor: pointer;
}
span:hover {
  color: #42b983;
}
</style>





// WEBPACK FOOTER //
// Localness.vue?1751377a